var CurrentUser = require("lib/account/CurrentUser");

import { connect } from "react-redux";
import { CircularProgressbar } from 'react-circular-progressbar';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';

class OnboardingProgressDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {  }
	}
	render() {
		var progress = this.props.current / this.props.total;
		var percent = Math.round(progress * 100);
		var imgPath = require("owls/official-owlfonso.png");
		
		return (
			<div className="circleContainer">
				<CircularProgressbarWithChildren value={ percent } className="largeCircle"
		            circleRatio={0.75}
		            styles={{
						trail: {
						strokeLinecap: 'butt',
						transform: 'rotate(-135deg)',
						transformOrigin: 'center center',
						},
						path: {
						strokeLinecap: 'butt',
						transform: 'rotate(-135deg)',
						transformOrigin: 'center center',
						}, }}>
				  	{/* Put any JSX content in here that you'd like. It'll be vertically and horizonally centered. */}
				  	<div className="infoContainer">
				  		<img src={ imgPath } alt="owlfonso" className="progressImg" />
				    	<p className="currentContainer">{ percent }%</p>
				  	</div>
				</CircularProgressbarWithChildren>
			</div>
		);
	}

	// componentDidMount() {
	// }
}

OnboardingProgressDisplay.propTypes = StrictPropTypes({
	metric: PropTypes.string,
	title: PropTypes.string,
	unit: PropTypes.string,
	current: PropTypes.number,
	total: PropTypes.number,
	actionLabel: PropTypes.string
});

module.exports = OnboardingProgressDisplay;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/onboarding/OnboardingProgressDisplay.js